import { BodyText, Col } from '@policygenius/mortar';
import { FC } from 'react';
import { createUseStyles } from 'react-jss';

import Button from 'components/Button';

import styles from './styles';
import { FormWrapperProps } from './types';

const useStyles = createUseStyles(styles, { name: 'FormWrapper' });

const FormWrapper: FC<FormWrapperProps> = ({
  children,
  handleSubmit,
  invalid,
  submitText = 'Next',
  submitting,
}) => {
  const classes = useStyles();

  return (
    <Col
      as="form"
      push={{ small: 0, medium: 2, large: 3 }}
      span={{ small: 4, medium: 8, large: 6 }}
      noValidate
      onSubmit={handleSubmit}
    >
      {children}
      <Button
        className={classes.submitButton}
        disabled={submitting || invalid}
        fullWidth
        type="submit"
      >
        {submitText}
      </Button>
      <BodyText className={classes.securityNote} color="primary">
        We don’t sell your personal information to third parties.
      </BodyText>
    </Col>
  );
};

export default FormWrapper;
